import React, { useState } from "react";

type TabsProps = {
  items: {
    label: string;
    onClick: Function;
  }[];
  width?: number;
  buttonWidth?: number;
  defaultSelectedIndex?: number;
  className?: string;
};

export default function Tabs({
  items,
  width,
  buttonWidth,
  defaultSelectedIndex,
  className,
}: TabsProps) {
  const [index, setIndex] = useState(
    typeof defaultSelectedIndex !== "undefined" ? defaultSelectedIndex : 0
  );
  return (
    <div className={"tabs" + (className ? " " + className : "")}>
      <div
        className={"grid"}
        style={{
          width: width ? width + "px" : "auto",
          gridTemplateColumns: `repeat(${items.length}, ${
            buttonWidth ? buttonWidth + "px" : "1fr"
          })`,
        }}
      >
        {items.map((item, i) => {
          return (
            <div key={i} className={i === index ? "tab selected" : "tab"}>
              <button
                className="reset block tac fz08"
                style={{ width: buttonWidth ? buttonWidth + "px" : "100%" }}
                onClick={() => {
                  item.onClick();
                  setIndex(i);
                }}
              >
                {item.label}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
